export enum ToastType {
    Info = 'Info',
    Warning = 'Warning',
    Error = 'Error',
    Success = 'Success',
}
